import React from "react";
import styled from "styled-components";

import { Box, Text } from "../ui";

const ShopNoOrders = () => {
    const StyledList = styled.ul`
        font-weight: bold;

        li {
            margin: 2rem 0;
        }

        a {
            color: #008755;
            font-size: 1.4rem;
        }
    `;

    return (
        <Box gap="16px">
            <Text as="h2" fontSize={["20px", "22px"]}>
                You have no transactions in the shop
            </Text>
            <Text fontSize={["14px", "16px"]}>
                View our collection of
            </Text>
            <StyledList>
                <li>
                    <a href="/Shop/Stamps-labels">Stamps & labels</a>
                </li>
                <li>
                    <a href="/Shop/Special-issue-stamps">Special issue stamps</a>
                </li>
                <li>
                    <a href="/Shop/Collectibles-gifts">Collectibles & Gifts</a>
                </li>
                <li>
                    <a href="/Shop/Mobile/Phones">Phones</a>
                </li>
            </StyledList>
        </Box>
    );
};

export default ShopNoOrders;
